import { SlatePlugin } from '../../../../slatePlugins/slatePlugins.types';
import { ELEMENT_NUMBERING } from './defaults';
import { renderNumberingElement } from './renderElement';
import { NumberingPluginOptions } from './types';

interface Options extends NumberingPluginOptions {
  mode?: string;
}

const deserializeNumberingElement = (el) => {
  if (el && el?.classList?.contains('numbering-element')) {
    return { type: ELEMENT_NUMBERING };
  }
  return undefined;
};

export const NumberingElementPlugin = (options?: Options): SlatePlugin => {
  return {
    renderElement: renderNumberingElement(options),
    inlineTypes: [ELEMENT_NUMBERING],
    deserialize: {
      element: [
        {
          type: 'numbering-element',
          deserialize: deserializeNumberingElement,
        },
      ],
    },
  };
};
